import { Injectable, StaticProvider } from '@angular/core';
import { Y42FeatureType } from '@y42/json-schema';
import { StatusAlertProviders } from '@y42/alert/feature/status-alert';
import { FeatureProvidersServiceInterface } from '@y42/feature';
import { ExportProviders } from '../export/export.provider';
import { IntegrationProviders } from '../integration/integration.provider';
import { SqlModelingProviders } from '../modeling/sql-modeling/sql-modeling.provider';
import { UiModelingProviders } from '../modeling/ui-modeling/ui-modeling.provider';
import { CatalogProviders } from '../catalog/catalog.provider';
import { DataLineageProviders } from '../data-lineage/data-lineage.provider';
import { OrchestrationProviders } from '../orchestration/orchestration.provider';
import { VisualizationDashboardProviders } from '../visualization/visualization-dashboard/visualization-dashboard.provider';
import { VisualizationWidgetProviders } from '../visualization/visualization-widget/visualization-widget.provider';

@Injectable()
export class FeatureProvidersService implements FeatureProvidersServiceInterface {
  prepareProviders(featureType: Y42FeatureType): StaticProvider[] {
    switch (featureType) {
      case Y42FeatureType.Integration:
        return IntegrationProviders();

      case Y42FeatureType.SqlModel:
        return SqlModelingProviders();

      case Y42FeatureType.UiModel:
        return UiModelingProviders();

      case Y42FeatureType.Export:
        return ExportProviders();

      case Y42FeatureType.Catalog:
        return CatalogProviders();

      case Y42FeatureType.Lineage:
        return DataLineageProviders();

      case Y42FeatureType.Orchestration:
        return OrchestrationProviders();

      case Y42FeatureType.StatusAlert:
        return StatusAlertProviders();

      case Y42FeatureType.VisualizationDashboard:
        return VisualizationDashboardProviders();

      case Y42FeatureType.VisualizationWidget:
        return VisualizationWidgetProviders();

      case Y42FeatureType.VisualizationFilter:
      case Y42FeatureType.VisualizationTheme:
        throw new Error(`Feature type ${featureType} is not supported`);
    }
  }
}
